module.exports = __webpack_public_path__ + "img/27ne.6d8b271a.svg";